"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PetamiAssetsParameters = void 0;
var PetamiAssetsParameters;
(function (PetamiAssetsParameters) {
    PetamiAssetsParameters["FOOD"] = "food";
    PetamiAssetsParameters["ACCESSORIES"] = "accessories";
})(PetamiAssetsParameters || (exports.PetamiAssetsParameters = PetamiAssetsParameters = {}));
//# sourceMappingURL=parameters.js.map